export const sourceSerialiser = (original) => ({
  source_data: {
    is_licensed: original?.isLicensed,
    source_name: original?.sourceName,
    source_type: original?.sourceType,
    upload_method: original?.uploadMethod,
  },
});
export const sourceDeserialiser = (original) => ({
  isLicensed: original?.is_licensed,
  sourceName: original?.source_name,
  sourceType: original?.source_type,
  uploadMethod: original?.upload_method,
});
